import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listItems = ({pagination, classroomIds, snapshotDateTime, folderId, searchTerm}) => {
  return POST('google/classroom/classwork/search', {
    pagination,
    classroomIds,
    snapshotDateTime,
    folderId,
    searchTerm: trimString(searchTerm)
  });
}

const listBreadcrumps = ({classroomId, folderId, snapshotDate}) => {
  return POST('google/classroom/classwork/breadcrumbs', {classroomId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, code}) => {
  const currentDate = new Date();

  return POST('google/classroom/classwork/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    selectedIds,
    TimeZoneOffset: currentDate.getTimezoneOffset()
  }, {code: code ? code : null})
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationId,
                           selectedIds,
                           RestoreType,
                           code
                         }) => {
  return POST('google/classroom/classwork/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    destinationId,
    selectedIds,
    RestoreType
  }, {code: code ? code : null})
}

export {
  listItems,
  listBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
